import { motion } from 'framer-motion';
import { Radio, Scissors, CalendarRange, LineChart } from 'lucide-react';
import { YouTubeVideo } from './YouTubeVideo';
import { ORB_VIDEOS } from '../config/orbConfig';

const PROOF_POINTS = [
  { icon: CalendarRange, label: '2022 → 2026', sub: 'Full 5-year backtest' },
  { icon: Scissors, label: 'No cuts', sub: 'No pauses, no edits' },
  { icon: Radio, label: 'Recorded live', sub: 'One continuous take' },
  { icon: LineChart, label: 'NinjaTrader 8', sub: 'Strategy Analyzer, A to Z' },
];

export const LiveBacktestVideo = () => (
  <section className="py-20" id="live-backtest" data-testid="orb-live-backtest-section">
    <div className="max-w-5xl mx-auto px-6">
      <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="mb-10">
        <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-red-500/10 border border-red-500/30 text-red-400 text-xs font-mono mb-4">
          <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" />
          FULL RECORDING
        </span>
        <h2 className="font-heading font-bold text-3xl md:text-4xl text-white mb-4">
          Watch the full backtest, <span className="text-[#06b6d4]">live, no cuts.</span>
        </h2>
        <p className="text-white/60 text-base md:text-lg max-w-3xl">
          Sahil runs the Monk Algo ORB backtest on NinjaTrader 8 from 2022 to 2026, from start to finish, in one continuous recording. Nothing is skipped, sped up or edited.
        </p>
      </motion.div>

      <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.1 }}
        className="relative">
        <div className="absolute -inset-4 bg-gradient-to-r from-[#7c3aed]/20 via-[#06b6d4]/10 to-[#10B981]/20 blur-3xl rounded-3xl pointer-events-none" />
        <div className="relative">
          <YouTubeVideo url={ORB_VIDEOS.liveBacktest} title="Monk Algo ORB: full live NinjaTrader 8 backtest, 2022 to 2026" accent="#7c3aed" testId="orb-live-backtest-video" thumbVersion={ORB_VIDEOS.thumbVersion} showPlayIcon={false} />
        </div>
      </motion.div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mt-8">
        {PROOF_POINTS.map(({ icon: Icon, label, sub }, i) => (
          <motion.div key={label} initial={{ opacity: 0, y: 12 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.15 + i * 0.07 }}
            className="glass rounded-xl p-4 border border-white/5" data-testid={`live-backtest-point-${i}`}>
            <Icon size={18} className="text-[#06b6d4] mb-2" />
            <p className="text-white font-heading font-semibold text-sm">{label}</p>
            <p className="text-white/40 text-xs mt-0.5">{sub}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
